import React from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';

import { useBodyScrollLock } from '@/hooks';

interface SportsSettingsModalProps {
  open: boolean;
  onClose: () => void;
  oddsFormat: 'price' | 'american' | 'decimal' | 'percentage';
  setOddsFormat: (format: 'price' | 'american' | 'decimal' | 'percentage') => void;
}

export const SportsSettingsModal = ({
  open,
  onClose,
  oddsFormat,
  setOddsFormat,
}: SportsSettingsModalProps) => {
  const oddsFormatOptions = ['price', 'american', 'decimal', 'percentage'] as const;

  useBodyScrollLock(open);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          maxWidth: { xs: '90vw', sm: 400 },
          m: { xs: 2, sm: 'auto' },
        },
      }}
    >
      <DialogTitle sx={{ fontSize: '1.25rem', fontWeight: 700, pb: 1 }}>Settings</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: '0.875rem', fontWeight: 600, mb: 2, color: 'text.primary' }}>
            Odds Format
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {oddsFormatOptions.map((format) => {
              const isActive = oddsFormat === format;
              return (
                <Button
                  key={format}
                  variant={isActive ? 'contained' : 'outlined'}
                  onClick={() => setOddsFormat(format)}
                  sx={{
                    flex: 1,
                    minWidth: 'fit-content',
                    textTransform: 'capitalize',
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    py: 1,
                    borderRadius: '6px',
                    bgcolor: isActive ? 'primary.main' : 'transparent',
                    color: isActive ? 'white' : 'text.primary',
                    borderColor: isActive ? 'primary.main' : 'divider',
                    '&:hover': {
                      bgcolor: isActive ? 'primary.dark' : 'action.hover',
                      borderColor: isActive ? 'primary.dark' : 'primary.main',
                    },
                  }}
                >
                  {format}
                </Button>
              );
            })}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
